import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { xs, md } = constants.breakpoints.BreakpointNames;
const { ui } = constants.colors;

const neutral700 = ui.neutral[700];
const neutral600 = ui.neutral[600];
const neutral25 = ui.neutral[25];
const white = ui.white[300];

const calcPercent = (achievedTokens, totalTokens) => {
  if (totalTokens > 0 && achievedTokens <= totalTokens)
    return `${(achievedTokens / totalTokens) * 100}%`;
  else if (totalTokens > 0 && achievedTokens >= totalTokens) return "100%";
  return "0%";
};

export const contentWrapper = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "left",
  color: neutral700,
  background: "#FFF",
  padding: "16px",
  [mq.downTo(xs)]: {
    padding: "40px",
  },
  [mq.downTo(md)]: {
    padding: "10px 80px",
  },
};

export const headerCss = {
  width: "100%",
  display: "flex",
};

export const tableWrapper = {
  width: "100%",
  display: "flex",
};

export const wrapperCss = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundImage: "none",
};

export const tableStructureCss = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  border: "none",
  thead: {
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    [mq.downTo(xs)]: {
      width: "100%",
    },
    flex: 1,
    tr: {
      width: "100%",
      display: "flex",
    },
    th: {
      cursor: "pointer",
      display: "flex",
      flex: 1,
      padding: "16px 12px",
      minWidth: "133px",
      [mq.downTo(xs)]: {
        minWidth: "130px",
      },
      "&:first-child": {
        borderRight: "1px solid #DDDDDD",
        button: {
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        },
      },
      button: {
        display: "flex",
        gap: "24px",
        overflow: "hidden",
        color: neutral700,
        textOverflow: "ellipsis",
        fontFamily: "Circular",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "114%" /* 15.96px */,
      },
    },
    td: {
      display: "flex",
      flex: 1,
      padding: "16px 12px",
    },
  },
  tbody: {
    display: "flex",
    flexDirection: "column",
    width: "fit-content",
    [mq.downTo(xs)]: {
      width: "100%",
    },
    flex: 1,
    tr: {
      width: "100%",
      display: "flex",
      "&:nth-child(odd)": {
        backgroundColor: neutral25,
      },
      "&:nth-child(even)": {
        backgroundColor: white,
      },
    },
    th: {
      cursor: "pointer",
      display: "flex",
      flex: 1,
      padding: "16px 12px",
      borderRight: "1px solid #DDDDDD",
      minWidth: "130px",
      // backgroundColor: 'transparent',
      textDecoration: "underline",
      color: neutral600,
      fontWeight: "400",
      lineHeight: "171%",
    },
    td: {
      display: "flex",
      flex: 1,
      padding: "16px 12px",
      minWidth: "130px",
    },
  },
};

export const paginationCss = {
  display: "flex",
  justifyContent: "end",
  marginTop: "24px",
  boxShadow: "none",
  border: "none",
};

export const pageSelectCss = {
  display: "none",
};

export const percentageTextCss = {
  color: neutral600,
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "150%",
  margin: 0,
};

export const progressBarContentCss = {
  width: "100%",
  height: "8px",
  border: `1px solid ${neutral600}`,
  borderRadius: "54px",
  backgroundColor: white,
};

export const progressPercentageCss = (achievedTokens, totalTokens) => ({
  width: calcPercent(achievedTokens, totalTokens),
  height: "100%",
  borderRadius: "56px",
  borderTopRightRadius:
    calcPercent(achievedTokens, totalTokens) === "100%" ? "56px" : "0",
  borderBottomRightRadius:
    calcPercent(achievedTokens, totalTokens) === "100%" ? "56px" : "0",
  backgroundColor: neutral700,
});

export const percentageWrapperCss = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

export const studentRowTokensWrapper = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const studentRowName = {
  overflow: "hidden",
  color: neutral600,
  textOverflow: "ellipsis",
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "150%" /* 24px */,
  margin: 0,
};

export const studentRowTokens = {
  margin: 0,
};

export const noDataAvailableCss = {
  fontSize: "12px",
  fontStyle: "italic",
  height: "100%",
};
